import { Pipe, PipeTransform } from '@angular/core';
import { classByKey, DocumentClassKey } from '../models/document-classes';

@Pipe({ name: 'classLabel' })
export class DocumentClassLabelPipe implements PipeTransform {
  transform(classKey: DocumentClassKey) {
    return classByKey[classKey].label;
  }
}
